import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import { getBboxPolygon } from '../../../helpers/gmaps';

import removeActiveShapes from '../../../helpers/removeActiveShapes';

import './style.scss';

const YouGotAwayMsg = ({
  map,
  show,
  drawingData,
  setDrawingData,
  setShow,
  searchMode,
}) => {
  const [shown, setShown] = useState(false);
  const [isUp, setIsUp] = useState(false);
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    if (!shown) {
      setShown(true);
    }
  }, [shown]);

  useEffect(() => {
    if (show && !isUp && !searchMode) {
      setIsUp(true);
      setTimeout(() => setVisible(true), 10);
    } else if ((!show && isUp) || searchMode) {
      setVisible(false);
      setTimeout(() => setIsUp(false), 305);
    }
  }, [show, isUp, searchMode]);

  const backToCenter = () => {
    if (!map || !drawingData) {
      return;
    }
    map.fitBounds(drawingData.shapeBounds);
  };

  const searchHere = () => {
    if (!map || !drawingData) {
      return;
    }

    removeActiveShapes({ drawingData });

    setShow(false);

    const newBounds = map.getBounds();
    const poly = JSON.parse(getBboxPolygon(newBounds));

    setDrawingData({
      action: 'draw',
      polygon: [...poly, poly[0]],
      from: 'got-away-msg',
      availableResults: {
        value: 0,
        loading: true,
      },
    });
  };

  return (
    <Grid className={`csa_mapsearch__bod__map__gotawaymsg pt--s pr--ms pb--ms pl--ms c-bg--w${isUp ? ' show' : ''}${visible ? ' visible' : ''}${shown ? ' shown' : ''}`} direction="column">
      <GridItem className="pb--s tp-s--m tp-w--s c-txt--f0 tp-a--c">
        {/* Ti sei allontanato dalla tua area disegnata */}Sei fuori dall'area di ricerca
      </GridItem>
      <GridItem>
        <Grid gutters="m">
          <GridItem>
            <div className="csa_mapsearch__bod__map__gotawaymsg__btn b--s tp-s--s tp-w--m c-bg--w c-txt--f0 is-clickable" onClick={backToCenter}>
              Torna all&apos;area
            </div>
          </GridItem>
          <GridItem>
            <div className="csa_mapsearch__bod__map__gotawaymsg__btn b--s tp-s--s tp-w--l c-bg--secondary c-br--secondary c-txt--w is-clickable" onClick={searchHere}>
              Nuova ricerca qui
            </div>
          </GridItem>
        </Grid>
      </GridItem>
    </Grid>
  );
};

export default YouGotAwayMsg;

YouGotAwayMsg.propTypes = {
  show: PropTypes.bool,
  map: PropTypes.instanceOf(Object),
  drawingData: PropTypes.instanceOf(Object),
  setDrawingData: PropTypes.func,
  updateQuery: PropTypes.func,
  setShow: PropTypes.func,
  searchMode: PropTypes.string,
};

YouGotAwayMsg.defaultProps = {
  show: false,
  map: null,
  drawingData: null,
  setDrawingData: () => {},
  updateQuery: () => {},
  setShow: () => {},
  searchMode: null,
};
